export default "__VITE_ASSET__rAkJS9cG__"